import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import api from '../axiosInterceptor';

type UpdateStudentContactPayload = {
  studentId: string;
  email: string;
  phone: string;
};

type UpdateStudentContactState = {
  loading: boolean;
  error: boolean;
  errorMessage: string;
  data: unknown | null;
};

const initialState: UpdateStudentContactState = {
  loading: false,
  error: false,
  errorMessage: '',
  data: null,
};

export const updateStudentContact = createAsyncThunk<
  unknown,
  UpdateStudentContactPayload
>('updateStudentContact', async ({ studentId, email, phone }) => {
  if (!studentId) {
    throw new Error('Missing student ID.');
  }
  const { data } = await api.post(`/api/coaches/me/students/${studentId}`, {
    email,
    phone,
  });
  return data;
});

const updateStudentContactSlice = createSlice({
  name: 'updateStudentContact',
  initialState,
  reducers: {
    resetUpdateStudentContact: (state) => {
      state.loading = false;
      state.error = false;
      state.errorMessage = '';
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(updateStudentContact.pending, (state) => {
      state.loading = true;
      state.error = false;
      state.errorMessage = '';
    });
    builder.addCase(updateStudentContact.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload;
    });
    builder.addCase(updateStudentContact.rejected, (state, action) => {
      state.loading = false;
      state.error = true;
      state.errorMessage =
        action.error.message ?? 'Failed to update student contact.';
    });
  },
});

export const { resetUpdateStudentContact } =
  updateStudentContactSlice.actions;
export default updateStudentContactSlice.reducer;
